var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emc-card-stats",
    {
      attrs: {
        icon: "mdi-timeline-clock-outline",
        color: "blue darken-2",
        "sheet-width": "50",
        "sheet-heigth": "50",
        "icon-class": "px-3 py-1",
        subtitle: _vm.subtitle,
        tools: !_vm.hideFooter,
        classSubTitle: _vm.classSubTitle,
      },
    },
    [
      _c(
        "template",
        { slot: "tools" },
        [
          !_vm.type
            ? _c("emc-button-icon", {
                attrs: {
                  loading: _vm.loading,
                  icon: "mdi-refresh-circle",
                  text: "Atualizar",
                  color: "success",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.refresh()
                  },
                },
              })
            : _vm._e(),
          _vm.showMoreButton
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: { color: "primary", icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "showMoreTimeTable",
                                          _vm.itemId
                                        )
                                      },
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { btn: "" } }, [
                                  _vm._v("mdi-monitor-eye"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    366991029
                  ),
                },
                [_c("span", [_vm._v(" Ver Mais... ")])]
              )
            : _vm._e(),
          !_vm.hideTools
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      color: "indigo darken-1",
                                      icon: "",
                                      small: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.download(112)
                                      },
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_c("v-icon", [_vm._v("mdi-microsoft-excel")])],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3168332574
                  ),
                },
                [_c("span", [_vm._v("Horários")])]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "v-progress-circular",
            {
              attrs: {
                rotate: 360,
                size: 140,
                width: 15,
                value:
                  _vm.schedule && _vm.schedule.percent
                    ? _vm.schedule.percent
                    : 0,
                color: "blue darken-2",
              },
            },
            [
              [
                _c("span", [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.schedule && _vm.schedule.percent
                          ? _vm.schedule.percent
                          : 0
                      ) + "%"
                    ),
                  ]),
                  _c("br"),
                  _vm.schedule && _vm.schedule.total
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.schedule.completed) +
                            " / " +
                            _vm._s(_vm.schedule.total)
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }